import { createContext, useState, useContext } from 'react';

// Criando o contexto
const CartContext = createContext();

// Criando um Provider personalizado
export function CartProvider({ children }) {
  const [cartItemCount, setCartItemCount] = useState(0);  
  const [cartItemTotal, setCartItemTotal] = useState(0);  
  
  // Função para fazer logout
  const removeCart = () => {
    localStorage.removeItem('cart');
    localStorage.removeItem('totalItem');
    localStorage.removeItem('tipoEntrega');
    localStorage.removeItem('valorDesconto');
    localStorage.removeItem('valorCashBack');
    localStorage.removeItem('endereco');
    localStorage.removeItem('dataHoraCart');
    localStorage.removeItem('coordsDest');
    localStorage.removeItem('distance');
    localStorage.removeItem('enderecoCliente');
    localStorage.removeItem('formaPagamento');
    localStorage.removeItem('taxaEntregaBairroId');
    setCartItemCount(0);
    setCartItemTotal(0);
    console.log('limpou o carrinho');
    
  };
  
  // Valores/funções que serão disponibilizados através do contexto
  const value = {
    cartItemCount,
    removeCart,
    setCartItemCount,
    cartItemTotal, 
    setCartItemTotal
  };
  
  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

// Hook personalizado para usar o contexto
export function useCart() {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart deve ser usado dentro de um CartProvider');
  }
  return context;
}
